import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
// import ClipLoader from "react-spinners/ClipLoader";
import { useSelector, useDispatch } from "react-redux";
import * as actions from "../../_redux/commentAction";
import { setHeightLayout, uppercaseFirstLetter } from "./../../helpers";
// import Editor from "@draft-js-plugins/editor";
import {
    setGuestInfo,
    setEditUsername,
    setUserInfo
} from "./../../_redux/commentSlice";
import { useTranslation, Trans } from "react-i18next";
import { Editor } from "@tinymce/tinymce-react";
// import Picker from "emoji-picker-react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

const Editors = ({
    isLogin,
    setIsWrite,
    onOpenCommentNotLogin,
    type,
    onSubmitReply,
    lastIndex
}) => {
    // __REDUX
    const { currentState } = useSelector(state => ({
        currentState: state.comment
    }));
    // const { executeRecaptcha } = useGoogleReCaptcha();
    const { models } = currentState;
    const { actionsLoading, commentSetting } = currentState;
    // const [editUsername, setEditUsername] = useState(false);
    const dispatch = useDispatch();
    // decode html
    const HtmlDecoded = str => {
        return str.replace(/(&#(\d+);)/g, function(match, capture, charCode) {
            return String.fromCharCode(charCode);
        });
    };
    // __STATE
    const {
        register,
        formState: { errors },
        watch,
        handleSubmit,
        reset,
        setValue,
        getValues,
        trigger
    } = useForm({
        defaultValues: {
            content: "",
            fullName: commentSetting.userInfo?.fullName
                ? HtmlDecoded(commentSetting.userInfo.fullName)
                : commentSetting.guestInfo.fullName,
            email: commentSetting.guestInfo.email
        }
    });
    const [isOpenEmojiList, setIsOpenEmojiList] = useState(false);
    // locales
    const { t } = useTranslation();
    // useRef()
    const targetEditor = useRef();
    const targetEmoji = useRef();
    // console.log(currentState);
    // EFFECT
    useEffect(() => {
        register("content", {
            required: true,
            validate: value => {
                if (value.trim() == "") return false;
                return true;
            },
            maxLength: 1500
        });
        watch("content");
    }, []);
    // submit data
    const onSubmit = async data => {
        // console.log(data);
        // const token = await executeRecaptcha();
        let request = {
            emailOrMobile:
                data.email !== ""
                    ? data?.email?.toLowerCase()
                    : commentSetting.userInfo.userId,
            fullName:
                data.fullName !== ""
                    ? uppercaseFirstLetter(
                          data.fullName
                              .trim()
                              .split(/^|\*|@|&|-|'|\(|\)|<|>|#$/g)
                              .join("")
                              .replace("*", "")
                      )
                    : commentSetting.userInfo.fullName,
            parentId: data.parentId,
            content: targetEditor.current.getContent(),
            answerId: data.answerId,
            categoryId: commentSetting.categoryId,
            objectId: commentSetting.objectId,
            title: commentSetting.title,
            categoryName: commentSetting.categoryName,
            websiteId: commentSetting.websiteId,
            viewUrl: commentSetting.viewUrl
            // GoogleRecaptchaValue: token
        };
        // console.log(request);
        // save guest info
        if (
            data.fullName !== "" &&
            data.email !== "" &&
            (data.email != commentSetting.guestInfo.email ||
                data.fullName != commentSetting.guestInfo.fullName)
        ) {
            dispatch(
                setGuestInfo({
                    data: {
                        email: data.email,
                        fullName: data.fullName
                    }
                })
            );
        }
        // has sourceType
        if (commentSetting?.sourceType)
            request.SourceType = commentSetting?.sourceType;
        dispatch(actions.commentAdd(request));
        reset({ content: "" });
        setIsWrite(false);
    };
    const onSubmitReplyComment = data => {
        onSubmitReply({ ...data, content: targetEditor.current.getContent() });
        reset({ content: "" });
        // save guest info
        if (
            data.fullName !== "" &&
            data.email !== "" &&
            (data.email != commentSetting.guestInfo.email ||
                data.fullName != commentSetting.guestInfo.fullName)
        ) {
            dispatch(
                setGuestInfo({
                    data: {
                        email: data.email,
                        fullName: data.fullName
                    }
                })
            );
        }
    };
    // content editor
    const onEditorChange = content => {
        setValue(
            "content",
            targetEditor.current.getContent({ format: "text" }),
            {
                shouldValidate: true
            }
        );
    };
    const onFocusEditor = () => {
        if (isOpenEmojiList) setIsOpenEmojiList(false);
    };
    // emoji event
    const onHandleEmojiChange = (event, emojiObject) => {
        targetEditor.current.selection.setContent(emojiObject);
    };
    // effect handle click outside in emoji
    useEffect(() => {
        function onHandleClickOutSide(e) {
            if (!targetEmoji.current.contains(e.target)) {
                if (isOpenEmojiList) setIsOpenEmojiList(false);
            }
        }
        document.addEventListener("click", onHandleClickOutSide);
        return () => {
            document.removeEventListener("click", onHandleClickOutSide);
        };
    }, [isOpenEmojiList]);
    const onToggleEmoji = () => {
        if (!isOpenEmojiList) {
            setIsOpenEmojiList(true);
            // // console.log(models.length);
            // if (models && models.length == 1) {
            //     setHeightLayout(105);
            // }
            // if (models && models.length == 2) {
            //     setHeightLayout(35);
            // }
            // if (!models || models?.length == 0) {
            //     setHeightLayout(135);
            // }
            // if (lastIndex) {
            //     setTimeout(
            //         () =>
            //             document
            //                 .querySelector(".emoji-picker-react")
            //                 ?.classList.add("position-top"),
            //         10
            //     );
            //     // document.querySelector('.ejr02pv').style.top = '-315px';
            // }
        } else {
            setIsOpenEmojiList(false);
            // setTimeout(
            //     () =>
            //         document
            //             .querySelector(".emoji-picker-react")
            //             ?.classList.remove("position-top"),
            //     10
            // );
            // setTimeout(() => {
            //     window.parent.postMessage(
            //         { clientHeight: document.body.offsetHeight + 10 },
            //         "*"
            //     );
            // }, 10);
        }
    };

    // change username
    const onHandleChangeUsername = boolean =>
        dispatch(setEditUsername(boolean));
    // func submit username
    const onHandleConfirmUsername = async () => {
        const isValid = await trigger("fullName", { shouldFocus: true });
        if (!isValid) return;
        const dataUpdate = {
            ...commentSetting.userInfo,
            fullName: getValues("fullName").trim()
        };
        // console.log(dataUpdate);
        dispatch(setUserInfo(dataUpdate));
        dispatch(setEditUsername(false));
    };
    return (
        <form
            onSubmit={handleSubmit(
                type == "reply" ? onSubmitReplyComment : onSubmit
            )}
            className='relative'>
            <div
                className={`relative wrapper__content--comment ${(errors.content
                    ?.type == "required" ||
                    errors.content?.type == "validate" ||
                    errors.content?.type == "maxLength") &&
                    "border-red-600"} cursor-text border min-h-[90px] mb-[5px] rounded-sm`}>
                <Editor
                    tinymceScriptSrc={
                        "https://static.vnncdn.net/tinymce/tinymce.min.js"
                    }
                    onInit={(evt, editor) => {
                        targetEditor.current = editor;
                        // focus editor
                        editor.focus();
                        window.parent.postMessage(
                            { clientHeight: document.body.offsetHeight },
                            "*"
                        );
                    }}
                    init={{
                        height: 90,
                        plugins: ["paste importcss searchreplace autoresize "],
                        menubar: false,
                        toolbar: false,
                        statusbar: false,
                        placeholder: "Bình luận của bạn....",
                        content_style:
                            "body { font-family:Arial; font-size:14px;margin:0px 10px;min-height:30px; }",
                        paste_preprocess: (plugin, args) => {
                            let content = args.content;
                            // console.log(content);
                            content = content.replace(/<p>\s*<\/p>/g, "");
                            var ua = navigator.userAgent.toLowerCase();
                            if (ua.indexOf("safari") <= -1) {
                                content = content.replace(/\s*<br \/>/g, "");
                                content = content.replace(/\s*<br\/>/g, "");
                            }
                            args.content = content;
                        },
                        paste_as_text: true,
                        autoresize_bottom_margin: 0,
                        // init_instance_callback:function(editor){
                        //     editor.on('input', function(input){
                        //         //console.log('Element input', input); // get all
                        //         console.log('Element input', input.rangeParent); // get rangeParent
                        //     });
                        // }
                        setup: function(ed) {
                            ed.on("keydown", function(e) {
                                // console.log(e.ctrlKey);
                                // alert(e.keyCode)
                                if (e.keyCode == 13) {
                                    window.parent.postMessage(
                                        {
                                            clientHeight:
                                                document.body.offsetHeight + 30
                                        },
                                        "*"
                                    );
                                } else {
                                    window.parent.postMessage(
                                        {
                                            clientHeight:
                                                document.body.offsetHeight
                                        },
                                        "*"
                                    );
                                }
                            });
                        }
                    }}
                    onEditorChange={onEditorChange}
                    onFocusIn={onFocusEditor}
                />
                {/* show số lượng kí tự */}
                {getValues("content").trim().length > 0 && (
                    <div className='text-[#666] absolute bottom-[5px] left-[10px] '>
                        <span className='mr-[2px] text-[13px] '>
                            {getValues("content").length}
                        </span>
                        <span className='mr-[2px] text-[13px]'>/</span>
                        <span className='text-[13px]'>
                            <Trans
                                i18nKey={"message.input.countCharacters"}
                                values={{ counts: 1500 }}
                            />
                        </span>
                    </div>
                )}
                {/* emoij picker react */}
            </div>
            {(errors.content?.type == "required" ||
                errors.content?.type == "validate") && (
                <p className='error__field mb-[7px] text-red-700 text-[13px] '>
                    {t("message.input.errors.content.empty")}
                </p>
            )}
            {errors.content?.type == "maxLength" && (
                <p className='error__field mb-[7px] text-red-700 text-[13px] '>
                    {t("message.input.errors.content.tooLong")}
                </p>
            )}
            <div
                className={`user__info ${
                    !isLogin ? "sm:justify-start justify-end" : "justify-end"
                } 
            flex flex-wrap`}>
                {!isLogin ? (
                    <React.Fragment>
                        <div className='sm:w-[40%] sm:mb-[0px] sm:mr-[5px] mb-[5px] w-full'>
                            <input
                                defaultValue={getValues("email")}
                                {...register("email", {
                                    required: true,
                                    pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
                                })}
                                style={{
                                    color:
                                        commentSetting?.version &&
                                        commentSetting?.version === "2.0.0" &&
                                        commentSetting.commentConfiguration
                                            .themeConfig.commentBlock
                                            .textInputColor
                                }}
                                className={`w-full border py-[5px] ${(errors
                                    .email?.type == "required" ||
                                    errors.email?.type == "pattern") &&
                                    "border-red-600"} px-[10px] focus:outline-none rounded-[5px]`}
                                type='text'
                                placeholder={t("message.input.email")}
                            />
                            {errors.email?.type == "required" && (
                                <p className='error__field mb-[7px] text-red-700 text-[13px] '>
                                    {t("message.input.errors.email.empty")}
                                </p>
                            )}
                            {errors.email?.type == "pattern" && (
                                <p className='error__field mb-[7px] text-red-700 text-[13px] '>
                                    {t("message.input.errors.email.invalid")}
                                </p>
                            )}
                        </div>
                        <div className='sm:w-[40%] sm:mb-[0px] mb-[5px] sm:mr-[5px] w-full'>
                            <input
                                defaultValue={getValues("fullName")}
                                {...register("fullName", {
                                    required: true,
                                    validate: value => {
                                        if (value.trim() == "") return false;
                                        return true;
                                    }
                                })}
                                style={{
                                    color:
                                        commentSetting?.version &&
                                        commentSetting?.version === "2.0.0" &&
                                        commentSetting.commentConfiguration
                                            .themeConfig.commentBlock
                                            .textInputColor
                                }}
                                className={`w-full border py-[5px] ${(errors
                                    .fullName?.type == "required" ||
                                    errors.fullName?.type == "validate") &&
                                    "border-red-600"} px-[10px] focus:outline-none rounded-[5px]`}
                                type='text'
                                placeholder={t("message.input.fullName")}
                            />
                            {(errors.fullName?.type == "required" ||
                                errors.fullName?.type == "validate") && (
                                <p className='error__field mb-[7px] text-red-700 text-[13px] '>
                                    {t("message.input.errors.fullName.empty")}
                                </p>
                            )}
                        </div>
                    </React.Fragment>
                ) : (
                    <div className='flex items-center mr-[10px] '>
                        {currentState.isEditUsername ? (
                            <div className='relative '>
                                <input
                                    className={`w-[280px] border py-[5px] false px-[10px] pr-[55px] focus:outline-none rounded-[5px]
                                    ${(errors.fullName?.type == "required" ||
                                        errors.fullName?.type == "validate") &&
                                        "border-red-600"}
                                `}
                                    type='text'
                                    defaultValue={getValues("fullName")}
                                    placeholder={t("message.input.fullName")}
                                    {...register("fullName", {
                                        required: true,
                                        validate: value => {
                                            if (value.trim() == "")
                                                return false;
                                            return true;
                                        }
                                    })}
                                />
                                {(errors.fullName?.type == "required" ||
                                    errors.fullName?.type == "validate") && (
                                    <p className='error__field mb-[7px] text-red-700 text-[13px] '>
                                        {t(
                                            "message.input.errors.fullName.empty"
                                        )}
                                    </p>
                                )}
                                <div className='group-action flex items-center top-[5px] right-[8px] absolute '>
                                    <button
                                        type='button'
                                        onClick={onHandleConfirmUsername}
                                        className='comment__active-closeBox cursor-pointer text-[16px] mr-[15px] group'>
                                        <i className='fa fa-check hover:text-black text-[#7b7b7b]'></i>
                                    </button>
                                    <button
                                        type='button'
                                        onClick={() =>
                                            onHandleChangeUsername(false)
                                        }
                                        className='comment__active-closeBox cursor-pointer text-[16px] group'>
                                        <i className='fa fa-times hover:text-black text-[#7b7b7b]'></i>
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <React.Fragment>
                                {commentSetting.userInfo?.userId ? (
                                    <div
                                        className='w-[25px] mr-[5px] rounded-full h-[25px] bg-no-repeat bg-cover bg-center'
                                        style={{
                                            backgroundImage: `url(${commentSetting.userInfo?.avatar})`
                                        }}>
                                        {commentSetting.userInfo?.avatar ==
                                            "" && (
                                            <span className='block rounded-full text-[12px] text-center text-white leading-[25px] bg-[#447ec5] w-[25px] h-[25px]'>
                                                {
                                                    commentSetting.userInfo
                                                        .shortName
                                                }
                                            </span>
                                        )}
                                    </div>
                                ) : (
                                    <img
                                        className='w-[25px] mr-[5px] object-cover rounded-full h-[25px] '
                                        src='https://static.vnncdn.net/ico/default-user-icon.svg'
                                        alt='Chưa đăng nhập'
                                    />
                                )}
                                <div className='my-auto leading-[18px]'>
                                    {/* font-weight-none */}
                                    <p className='font-arial font-semibold sm:font-no tosans-bold'>
                                        {HtmlDecoded(
                                            commentSetting.userInfo.fullName
                                        )}
                                    </p>
                                    <button
                                        onClick={() =>
                                            onHandleChangeUsername(true)
                                        }
                                        style={{
                                            color:
                                                commentSetting?.version &&
                                                commentSetting?.version ===
                                                    "2.0.0" &&
                                                commentSetting
                                                    .commentConfiguration
                                                    .themeConfig.commentBlock
                                                    .textUsernameColor
                                        }}
                                        type='button'
                                        className='text-[13px] font-notosans-italic text-[#2d67ad] underline '>
                                        Sử dụng tên hiển thị khác?
                                    </button>
                                </div>
                            </React.Fragment>
                        )}
                    </div>
                )}
                {!currentState.isEditUsername && (
                    <button
                        style={{
                            backgroundColor:
                                commentSetting?.version &&
                                commentSetting?.version === "2.0.0"
                                    ? commentSetting.commentConfiguration
                                          .themeConfig.commentBlock
                                          .backgroundButtonColor
                                    : commentSetting?.theme?.backgroundColor,
                            color:
                                commentSetting?.version &&
                                commentSetting?.version === "2.0.0" &&
                                commentSetting.commentConfiguration.themeConfig
                                    .commentBlock.textButtonColor
                        }}
                        disabled={actionsLoading}
                        type='submit'
                        className='h-[33px] py-[5px] 
                 hover:bg-[#177fce] disabled:bg-gray-600 px-[20px] border rounded-[5px] 
                 text-white flex gap-[5px] items-center '>
                        {actionsLoading && (
                            <React.Fragment>react-spinners</React.Fragment>
                        )}
                        <span>{t("message.input.send")}</span>
                    </button>
                )}
            </div>
            {/* close button */}
            <div
                onClick={() => {
                    setTimeout(() => {
                        window.parent.postMessage(
                            { clientHeight: document.body.offsetHeight + 10 },
                            "*"
                        );
                    }, 10);
                    if (isLogin) {
                        return setIsWrite(false);
                    }
                    onOpenCommentNotLogin(false);
                }}
                className='comment__active-closeBox cursor-pointer text-[16px] group top-[5px] right-[9px] absolute'>
                <i className='fa fa-times hover:text-black text-[#7b7b7b]'></i>
            </div>
            {/* emoji icon */}
            <button
                onClick={onToggleEmoji}
                type='button'
                className='emoij-button'>
                <img
                    src='https://static.vnncdn.net/v1/icon/happy.png'
                    alt='happy icon'
                />
            </button>
            <div ref={targetEmoji} className='groupEmoji'>
                {isOpenEmojiList && (
                    <div className='emoji-data absolute w-[190px] right-[30px] top-0 border rounded bg-white shadow-sm p-[5px]  '>
                        {[
                            "😀",
                            "😍",
                            "😄",
                            "😁",
                            "😆",
                            "😅",
                            "🤣",
                            "😂",
                            "😝",
                            "🥰",
                            "😘",
                            "😰",
                            "🤮",
                            "😫",
                            "😡"
                        ].map(emoji => {
                            return (
                                <button
                                    onClick={e => onHandleEmojiChange(e, emoji)}
                                    className='text-[25px] '
                                    type='button'>
                                    {emoji}
                                </button>
                            );
                        })}
                    </div>
                )}
            </div>
        </form>
    );
};

export default React.memo(Editors);
